import { render } from "./EditPayCurrency.vue?vue&type=template&id=1782b9c7"
import script from "./EditPayCurrency.vue?vue&type=script&lang=js"
export * from "./EditPayCurrency.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__